import { Box, useStyleConfig } from "@chakra-ui/react";

export default function BackgroundGradient(props) {
    const { variant, gradient, ...rest } = props;
    const styles = useStyleConfig("BackgroundGradient", { variant });

    return <Box sx={styles} backgroundImage={gradient} {...rest}></Box>;
}
